import React from 'react';

import { ContextValue } from './types';

const defaultContext = {
  token: null,
  twoFactorAuthData: {},
  setTwoFactorAuthData() {
    /* empty */
  },
  signIn(username: string, password: string) {
    return Promise.reject(undefined);
  },
  signOut() {
    /* empty */
  },
  forgotPassword(username: string) {
    return Promise.reject(undefined);
  },
  resetPassword(username: string, password: string, token: string) {
    return Promise.reject(undefined);
  },
  setPassword(password: string, token: string) {
    return Promise.reject(undefined);
  }
};

const AuthContext = React.createContext<ContextValue>(defaultContext);
export default AuthContext;
